var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-body header",attrs:{"flex":"","fic":"","fjc":""}},[_c('div',{staticClass:"w8 mw11 logo-layout",attrs:{"flex":"","fic":"","fjs":""}},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("../assets/upicklogo.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }